<!-- Header -->
<app-header></app-header>

<!-- Main content -->
<div
  class="px-6 xl:px-20 py-10 text-gray-800 flex flex-col justify-center items-center font-arimo"
>
  <div class="max-w-7xl">
    <!-- FAQ Section -->
    <div class="text-center mb-10 flex flex-col items-center">
      <img
        src="assets/icons/faq-main.svg"
        [alt]="'FAQ_PAGE.MAIN_ICON_ALT' | translate"
      />
      <div class="flex w-full items-center justify-center gap-4 py-8">
        <div class="w-16 h-[3px] bg-[#00D5BE]"></div>
        <h1 class="text-4xl font-bold text-gray-800">
          {{ "FAQ_PAGE.TITLE" | translate }}
        </h1>
        <div class="w-16 h-[3px] bg-[#00D5BE]"></div>
      </div>
      <p>{{ "FAQ_PAGE.SUBTITLE" | translate }}</p>
    </div>

    <div class="w-[1000px] mx-auto p-4">
      <!-- FAQ Section -->
      <div class="w-full bg-white rounded-2xl shadow-xl mb-6 border">
        <div class="space-y-4">
          <div
            *ngFor="let item of faqItems; let i = index"
            class="border-b border-gray-300 last:border-b-0 px-6 py-2"
          >
            <button
              (click)="toggleFaq(i)"
              class="w-full flex items-center justify-between py-4 text-left hover:text-teal-600 transition-colors"
            >
              <span class="text-black font-normal pr-4">
                <span class="text-[#009689]">- </span>
                {{ item.question | translate }}
              </span>
              <svg
                [class.rotate-180]="item.isOpen"
                class="w-5 h-5 text-gray-400 transition-transform duration-300 flex-shrink-0"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M19 9l-7 7-7-7"
                ></path>
              </svg>
            </button>

            <div
              *ngIf="item.isOpen"
              class="pb-4 pl-4 text-gray-600 text-sm leading-relaxed animate-slideDown"
            >
              {{ item.answer | translate }}
            </div>
          </div>
        </div>
      </div>

      <!-- Contact Section -->
      <div
        class="bg-gradient-to-r from-[#009689] to-[#009966] rounded-2xl shadow-lg text-center text-white"
      >
        <div class="p-8">
          <h2 class="text-2xl font-semibold mb-2">
            {{ "FAQ_PAGE.CTA.TITLE" | translate }}
          </h2>
          <p class="text-[#CBFBF1] mb-6">
            {{ "FAQ_PAGE.CTA.SUBTITLE" | translate }}
          </p>

          <div
            class="flex flex-col sm:flex-row gap-3 justify-center items-center"
          >
            <a href="/contact">
              <button
                class="bg-white text-teal-600 px-6 py-2.5 rounded-lg font-medium hover:bg-teal-50 transition-colors flex items-center gap-2 shadow-sm"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4.60768 11.6673C5.72102 12.2385 7.00173 12.3932 8.21903 12.1035C9.43633 11.8139 10.5102 11.0991 11.247 10.0878C11.9839 9.07649 12.3353 7.83526 12.238 6.58777C12.1407 5.34029 11.601 4.16858 10.7162 3.28379C9.83145 2.399 8.65974 1.85933 7.41225 1.762C6.16477 1.66468 4.92354 2.01612 3.91224 2.75299C2.90095 3.48986 2.18609 4.56369 1.89648 5.78099C1.60687 6.99829 1.76157 8.27901 2.33268 9.39234L1.16602 12.834L4.60768 11.6673Z"
                    stroke="#00786F"
                    stroke-width="1.16667"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                {{ "FAQ_PAGE.CTA.BUTTON_SUPPORT" | translate }}
              </button>
            </a>
          </div>
        </div>

        <div
          class="flex items-center justify-center gap-2 text-[#CBFBF1] text-sm border-t border-[#00BBA7] p-8"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_2714_1973)">
              <path
                d="M8.06802 9.66402C8.18849 9.71934 8.32422 9.73198 8.45284 9.69986C8.58146 9.66773 8.69529 9.59275 8.7756 9.48727L8.98268 9.21602C9.09135 9.07112 9.23227 8.95352 9.39427 8.87252C9.55627 8.79152 9.7349 8.74935 9.91602 8.74935H11.666C11.9754 8.74935 12.2722 8.87227 12.491 9.09106C12.7098 9.30985 12.8327 9.6066 12.8327 9.91602V11.666C12.8327 11.9754 12.7098 12.2722 12.491 12.491C12.2722 12.7098 11.9754 12.8327 11.666 12.8327C8.88124 12.8327 6.21053 11.7264 4.24139 9.7573C2.27226 7.78817 1.16602 5.11746 1.16602 2.33268C1.16602 2.02326 1.28893 1.72652 1.50772 1.50772C1.72652 1.28893 2.02326 1.16602 2.33268 1.16602H4.08268C4.3921 1.16602 4.68885 1.28893 4.90764 1.50772C5.12643 1.72652 5.24935 2.02326 5.24935 2.33268V4.08268C5.24935 4.2638 5.20718 4.44243 5.12618 4.60443C5.04518 4.76643 4.92758 4.90734 4.78268 5.01602L4.50968 5.22077C4.40259 5.30254 4.32711 5.41886 4.29606 5.54997C4.26501 5.68108 4.28031 5.8189 4.33935 5.94002C5.13658 7.55927 6.44776 8.86881 8.06802 9.66402Z"
                stroke="#CBFBF1"
                stroke-width="1.16667"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_2714_1973">
                <rect width="14" height="14" fill="white" />
              </clipPath>
            </defs>
          </svg>
          {{ "FAQ_PAGE.CTA.HOURS" | translate }}
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Footer -->
<app-footer layout="slim"></app-footer>
